import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppService } from '@app/app.service';
import { CoreModule } from '@app/core/core.module';
import { AuthService } from '@app/shared/auth/auth.service';
import { LoadDataService } from '@app/shared/services/load-data.service';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

/*
import * as appData from '../assets/json/appData.json'
 */

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, CoreModule, SharedModule, TranslateModule, RouterModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {

    private appData = inject(AppService);
    private loadData = inject(LoadDataService);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
    ) {}

    ngOnInit() {

        this.authService.token = this.route.snapshot.params.token;
        this.authService.changeTokenIsValid(true);
        //this.loadData.loadOperation(this.authService.token);

        this.router.navigate(['/main/financing-start'], { relativeTo: this.route });
    }


}
